import { enqueueSnackbar } from "notistack";
import {
  deletePatientOscillaApi,
  getPatientOscillaApi,
} from "../../apis/oscilla.api";
import { actions, SNACK_BAR_VARIETNS } from "../../utils/constants";
import { AudiosGramData } from "../../utils/helper";
import { callApiAction } from "./commonAction";
import { callSnackBar } from "./snackbarAction";

export const fetchOscillaDetails = (id, onSuccess, onError) => {
  return async (dispatch, getState) => {
    dispatch(
      callApiAction(
        async () => await getPatientOscillaApi({ id }),
        (response) => {
          dispatch({
            type: actions.SET_OSCILLA_PATIENT_DETAILS,
            value: response[0],
          });

          if (response[0]?.isDeleted) {
            if (response[0]?.isServerError) {
              enqueueSnackbar(
                "Server error. Please check your connection or try again later.",
                {
                  variant: "error",
                  autoHideDuration: 15000,
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                },
              );
            }
            dispatch(DeleteOscillaDetails(response[0]?._id, id));
          } else {
            dispatch({
              type: actions.SET_OSCILLA_PATIENT_DETAILS,
              value: response[0],
            });
          }
          dispatch(startOscillaLoadingValues(false));
        },
        (err) => {
          // onError(err)
          dispatch(startOscillaLoadingValues(false));
        },
      ),
    );
  };
};

export const fetchOscillaTestStartedDetails = (id, onSuccess, onError) => {
  return async (dispatch, getState) => {
    dispatch(
      callApiAction(
        async () => await getPatientOscillaApi({ id: id }),
        (response) => {
          if (response[0]?.isDeleted) {
            if (response[0]?.isServerError) {
              enqueueSnackbar(
                "Server error. Please check your connection or try again later.",
                {
                  variant: "error",
                  autoHideDuration: 15000,
                  anchorOrigin: { vertical: "bottom", horizontal: "left" },
                },
              );
            }
            dispatch(DeleteOscillaDetails(response[0]?._id));
          } else {
            dispatch({
              type: actions.TEST_OSCILLA_PATIENT_DETAILS,
              value: response[0],
            });
          }
        },
        (err) => {
          // onError(err)
          dispatch(startOscillaLoadingValues(false));
        },
      ),
    );
  };
};

export const startOscillaLoadingValues = (value) => {
  return { type: actions.START_OSCILLA_LOADING_VALUES, value: value };
};

export const DeleteOscillaDetails = (id, _id) => {
  return async (dispatch, getState) => {
    dispatch(
      callApiAction(
        async () => await deletePatientOscillaApi({ id }),
        (response) => {
          dispatch(startOscillaLoadingValues(false));
          if (_id) {
            dispatch(fetchOscillaDetails(_id));
          }
        },
        (err) => {
          // onError(err)
          dispatch(startOscillaLoadingValues(false));
        },
      ),
    );
  };
};
